import React, {
  useEffect,
  useState,
  Fragment,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { Grid, notification, Checkbox, Radio } from "antd";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { Input as Input, Button, Box, Pagination, Select } from "components";
import { DownloadIcon, SendCompleteIcon, ConfirmFailIcon } from "icons";
import { generateCSV } from "utils";
import { useSmartLoading, useDebouncedAction } from "hooks";
import { httpStatus } from "configs/httpStatus";

import { PatientsPayload } from "models/patients/patientList";
import {
  GetPatientsActionCreators,
  DownloadPatientsCSVActionCreators,
  DeletePatientActionCreators,
  SubscribeSuperCityActionCreators,
} from "redux/rootActions";
import {
  selectIsLoadingPatientList,
  selectpatientListErrorMessage,
  patientListDataResponse,
} from "redux/patients/patientList/patientListStates";
import {
  selectIsLoadingPatientCSV,
  selectpatientCSVErrorMessage,
  patientCSVDataResponse,
} from "redux/patients/downloadPatientCSV/downloadPatientCSVStates";
import {
  selectIsDeletingPatient,
  selectDeletePatientErrorMessage,
  deletePatientResponse,
} from "redux/patients/deletePatient/deletePatientStates";
import { settingInformationDataResponse } from "redux/setting/general/generalSettingStates";
import {
  selectSubscribingSuperCity,
  selectSubscribeSuperCityErrorMessage,
  subscribeSuperCityResponse,
} from "redux/patients/subscribeSuperCity/subscribeSuperCityStates";

import {
  PaginationWrapper,
  ContentWrapper,
  SearchWrapper,
  SearchWrapperLeft,
  WrapperSelectAndBtn,
  RowCellWrapper,
  SelectWrapper,
  ModalStyled,
  WrapperBtnFooter,
  TableStyled,
  TextLink,
  TextModal,
  TaskWrapper,
  ActionWrapper,
  WrapperMessage,
  Message,
  Item,
  CheckboxStyled,
  WrapperCheckboxAll,
  DotLine,
  BirthdayBadge,
  JoinBadge,
  RegistrationBadge,
  WrapperBadge,
  OtherBadge,
  WrapperCommonInfor,
  UserInputButtonWrapper,
  FilterWrapper,
  CheckboxStyled2,
  CheckboxTopWrapper,
  ListUserWrapper,
  IdentityBadge,
  ListUserWrapper2,
  LoadingWrapper,
  WrapperExtra,
  AudioWrapper,
  FixedWidthName,
} from "./UserList.style";
import { Loading } from "./components";

type SearchType =
  | "birthdate"
  | "registration_date"
  | "user_name"
  | "registration_number";
interface ISelectedPatient {
  name: string;
  id: any;
  user_id: any;
}

const { useBreakpoint } = Grid;

const currentYear = new Date().getFullYear();
export const yearOptions: any = [
  {
    id: 0,
    value: "",
    name: "----",
  },
];
for (let i = currentYear; i >= 1900; i--) {
  yearOptions.push({
    id: i,
    value: i,
    name: i,
  });
}

export const monthOptions: any = [
  {
    id: 0,
    value: "",
    name: "--",
  },
];
for (let i = 1; i <= 12; i++) {
  if (i <= 9) {
    monthOptions.push({
      id: i,
      value: i,
      name: `0${i}`,
    });
  } else {
    monthOptions.push({
      id: i,
      value: i,
      name: i,
    });
  }
}

const recordOptions = [
  {
    id: 1,
    name: `10件`,
    value: 10,
  },
  {
    id: 2,
    name: `50件`,
    value: 50,
  },
  {
    id: 3,
    name: `100件`,
    value: 100,
  },
  {
    id: 4,
    name: `150件`,
    value: 150,
  },
  {
    id: 5,
    name: `200件`,
    value: 200,
  },
];

const dayOptionsDefault: any = [
  {
    id: 0,
    value: "",
    name: "--",
  },
];
for (let i = 1; i <= 31; i++) {
  if (i <= 9) {
    dayOptionsDefault.push({
      id: i,
      value: i,
      name: `0${i}`,
    });
  } else {
    dayOptionsDefault.push({
      id: i,
      value: i,
      name: i,
    });
  }
}

const defaultInput: any = {
  page: 1,
  per_page: 10,
  user_name: "",
  from_date: "",
  to_date: "",
  is_in_super_city: false,
};

const FIXED_NAME_WIDTH = 275;

const UserList: React.FC = () => {
  const screens = useBreakpoint();
  const dispatch = useDispatch();
  const { watch, handleSubmit, control, setValue } = useForm();

  const watchStartYear = watch("startYear");
  const watchEndYear = watch("endYear");
  const watchStartMonth = watch("startMonth");
  const watchEndMonth = watch("endMonth");
  const watchStartDate = watch("startDate");
  const watchEndDate = watch("endDate");

  const isLoadingPatientsList = useSelector(selectIsLoadingPatientList);
  const isDownloadingPatients = useSelector(selectIsLoadingPatientCSV);
  const isDeletingPatient = useSelector(selectIsDeletingPatient);
  const subscribingSuperCity = useSelector(selectSubscribingSuperCity);

  const patientListError = useSelector(selectpatientListErrorMessage);
  const downloadPatientCSVError = useSelector(selectpatientCSVErrorMessage);
  const deletePatientError = useSelector(selectDeletePatientErrorMessage);
  const subscribeError = useSelector(selectSubscribeSuperCityErrorMessage);

  const patientListData = useSelector(patientListDataResponse);
  const patientCSVData = useSelector(patientCSVDataResponse);
  const deletePatientData = useSelector(deletePatientResponse);
  const settingInformationData = useSelector(settingInformationDataResponse);
  const subscribeSuperCityData = useSelector(subscribeSuperCityResponse);

  const onlinePatientDeleted = false;
  const scrollAbleRef = useRef<any>(undefined);
  const tableCopyRef = useRef<any>(undefined);

  const [input, setInput] = useState<PatientsPayload>(defaultInput);
  const [isVisible, setIsVisible] = useState(false);
  const [
    isVisible4DeleteGroupRegistration,
    setIsVisible4DeleteGroupRegistration,
  ] = useState(false);
  // const [recordOptions, setRecordOptions] = useState<IOption[]>([

  // ]);
  const [selectedPatient, setSelectedPatient] = useState<ISelectedPatient>({
    id: undefined,
    user_id: undefined,
    name: "",
  });
  const [isDisabled, setIsDisabled] = useState(true);
  const [list, setList] = useState<any>([]);
  const [checkedList, setCheckedList] = useState<any>([]);
  const [endYearOptions, setEndYearOptions] = useState([]);
  const [endMonthOptions, setEndMonthOptions] = useState([]);
  const [startMonthOptions, setStartMonthOptions] = useState([]);
  const [allSuperCityUser, setAllSuperCityUser] = useState<any[]>([]);
  const [allSuperCityPatients, setAllSuperCityPatients] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [totalPatient, setTotalPatient] = useState(0);
  const [totalPatientSuperCity, setTotalPatientSuperCity] = useState(0);
  const [startDayOptions, setStartDayOptions] = useState(dayOptionsDefault);
  const [endDayOptions, setEndDayOptions] = useState(dayOptionsDefault);
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [isCheckAll, setisCheckAll] = useState(false);
  const [matchedItems, setMatchedItems] = useState<any[]>([]);
  const [searchType, setSearchType] = useState<SearchType>("birthdate");

  const loadingDelete = useSmartLoading(isDeletingPatient);
  const loadingSubscribe = useSmartLoading(subscribingSuperCity);

  const totalUsers = useMemo<number>(() => {
    return patientListData?.total_record || 0;
  }, [patientListData]);

  const daysOfStartMonth = useMemo<number>(() => {
    return moment(
      `${watchStartYear}-${watchStartMonth}`,
      "YYYY-MM"
    ).daysInMonth();
  }, [watchStartYear, watchStartMonth]);

  const daysOfEndMonth = useMemo<number>(() => {
    return moment(
      `${watchEndYear || watchStartYear}-${watchEndMonth}`,
      "YYYY-MM"
    ).daysInMonth();
  }, [watchEndYear, watchEndMonth, watchStartYear]);

  const startDate = useMemo<string>(() => {
    if (watchStartYear) {
      return moment(
        `${watchStartYear}-${watchStartMonth || "01"}-${watchStartDate || "01"}`
      ).toString();
    } else return "";
  }, [watchStartYear, watchStartMonth, watchStartDate]);

  const endDate = useMemo<string>(() => {
    if (watchEndYear) {
      return moment(
        `${watchEndYear}-${watchEndMonth || "12"}-${
          watchEndDate || daysOfEndMonth
        }`
      ).toString();
    } else {
      if (watchStartYear) {
        return moment(
          `${watchStartYear}-${watchEndMonth || "12"}-${
            watchEndDate || daysOfEndMonth
          }`
        ).toString();
      } else return "";
    }
  }, [watchEndYear, watchEndMonth, watchEndDate]);

  const isResetEndDate = useMemo<boolean>(() => {
    if (!endDate || (!startDate && !endDate)) {
      return false;
    } else {
      if (moment(startDate).diff(endDate) >= 0) {
        return true;
      } else {
        return false;
      }
    }
  }, [startDate, endDate]);

  const isHouseholdBased = useMemo<boolean>(() => {
    return settingInformationData?.result?.super_city_condition
      ?.is_household_based;
  }, [settingInformationData]);

  const conditionMethod = useMemo(
    () =>
      settingInformationData?.result?.super_city_condition?.condition_method,
    [settingInformationData]
  );

  const upperAge = useMemo<string>(() => {
    if (!settingInformationData?.result?.super_city_condition?.upper_age)
      return "";
    return settingInformationData.result.super_city_condition.upper_age;
  }, [settingInformationData]);

  const lowerAge = useMemo<string>(() => {
    if (!settingInformationData?.result?.super_city_condition?.lower_age)
      return "";
    return settingInformationData.result.super_city_condition.lower_age;
  }, [settingInformationData]);

  const upperVal = useMemo<string>(() => {
    if (!settingInformationData?.result?.super_city_condition?.upper_value)
      return "";
    return settingInformationData.result.super_city_condition.upper_value;
  }, [settingInformationData]);

  const lowerVal = useMemo<string>(() => {
    if (!settingInformationData?.result?.super_city_condition?.lower_value)
      return "";
    return settingInformationData.result.super_city_condition.lower_value;
  }, [settingInformationData]);

  const checkDisplayConditionAge = (record: any) => {
    if (upperAge && lowerAge) {
      return record.age <= upperAge && record.age >= lowerAge;
    } else {
      if (upperAge) {
        return record.age <= upperAge;
      }
      if (lowerAge) {
        return record.age >= lowerAge;
      }
    }
  };

  const checkDisplayConditionDate = (record: any) => {
    if (upperVal && lowerVal) {
      return (
        record.date_of_birth >= upperVal && record.date_of_birth <= lowerVal
      );
    } else {
      if (upperVal) {
        return record.date_of_birth >= upperVal;
      }
      if (lowerVal) {
        return record.date_of_birth <= lowerVal;
      }
    }
  };

  const checkDisplayRegisterButton = (patients: any[], record: any) => {
    if (!conditionMethod) {
      return true;
    } else {
      if (conditionMethod === "birthdate") {
        if (!upperVal && !lowerVal) {
          return true;
        } else {
          if (
            patients.some((patient: any) => checkDisplayConditionDate(patient))
          ) {
            if (isHouseholdBased) return true;
            return checkDisplayConditionDate(record);
          } else {
            return false;
          }
        }
      }
      if (conditionMethod === "age") {
        if (!upperAge && !lowerAge) {
          return true;
        } else {
          if (
            patients.some((patient: any) => checkDisplayConditionAge(patient))
          ) {
            if (isHouseholdBased) return true;
            return checkDisplayConditionAge(record);
          } else {
            return false;
          }
        }
      }
    }
  };

  const transformParams = (inputs: PatientsPayload) => {
    const convertedInputs: any = {
      page: inputs.page,
      per_page: inputs.per_page,
      is_in_super_city: inputs.is_in_super_city,
    };
    if (searchType === "birthdate") {
      convertedInputs.from_date = inputs.from_date;
      convertedInputs.to_date = inputs.to_date;
    } else if (searchType === "registration_date") {
      convertedInputs.join_from_date = inputs.from_date;
      convertedInputs.join_to_date = inputs.to_date;
    } else if (searchType === "user_name") {
      convertedInputs.user_name = inputs.user_name;
    } else if (searchType === "registration_number") {
      convertedInputs.identity_code = inputs.user_name;
    }
    return convertedInputs;
  };

  const resetEndDate = () => {
    setValue("endYear", undefined);
    setValue("endMonth", undefined);
    setValue("endDate", undefined);
  };

  const resetAllDate = () => {
    setValue("startYear", undefined);
    setValue("startMonth", undefined);
    setValue("startDate", undefined);
    setValue("endYear", undefined);
    setValue("endMonth", undefined);
    setValue("endDate", undefined);
    setValue("name", "");
    setInput({ ...defaultInput, page: 1, per_page: input.per_page });
    setIsSearching(false);
    dispatch(
      GetPatientsActionCreators.getPatientListAction({
        ...defaultInput,
        page: 1,
        per_page: input.per_page,
      })
    );
  };

  const handleOptions = (num: number, current?: any) => {
    const arr: any = [
      {
        id: 0,
        value: "",
        name: "--",
      },
    ];

    for (let i = 1; i <= num; i++) {
      if (i <= 9) {
        let item: any = {
          id: i,
          value: i,
          name: `0${i}`,
        };
        if (current) {
          item = {
            ...item,
            disabled: current <= i ? false : true,
          };
        }
        arr.push(item);
      } else {
        let item: any = {
          id: i,
          value: i,
          name: i,
        };
        if (current) {
          item = {
            ...item,
            disabled: current <= i ? false : true,
          };
        }
        arr.push(item);
      }
    }

    return arr;
  };

  const handleOptions2 = (num: number, current?: any) => {
    const arr: any = [
      {
        id: 0,
        value: "",
        name: "--",
      },
    ];

    for (let i = 1; i <= num; i++) {
      if (i <= 9) {
        let item: any = {
          id: i,
          value: i,
          name: `0${i}`,
        };
        if (current) {
          item = {
            ...item,
            disabled: current >= i ? false : true,
          };
        }
        arr.push(item);
      } else {
        let item: any = {
          id: i,
          value: i,
          name: i,
        };
        if (current) {
          item = {
            ...item,
            disabled: current >= i ? false : true,
          };
        }
        arr.push(item);
      }
    }

    return arr;
  };
  const handleOptions3 = (num: number, current?: any, max?: any) => {
    const arr: any = [
      {
        id: 0,
        value: "",
        name: "--",
      },
    ];

    for (let i = 1; i <= num; i++) {
      if (i <= 9) {
        let item: any = {
          id: i,
          value: i,
          name: `0${i}`,
        };
        if (current) {
          item = {
            ...item,
            disabled: current <= i && i <= max ? false : true,
          };
        }
        arr.push(item);
      } else {
        let item: any = {
          id: i,
          value: i,
          name: i,
        };
        if (current) {
          item = {
            ...item,
            disabled: current <= i && i <= max ? false : true,
          };
        }
        arr.push(item);
      }
    }

    return arr;
  };

  const indeterminate =
    checkedList.length > 0 && checkedList.length < allSuperCityPatients.length;
  const indeterminate2 =
    checkedList.length > 0 &&
    // checkedList.length < matchedItems?.length &&
    checkedList.some((item: any) => matchedItems.includes(item)) &&
    !matchedItems.every((item: any) => checkedList.includes(item))
      ? true
      : false;

  const checkAll = useMemo<boolean>(() => {
    if (
      allSuperCityPatients?.length &&
      allSuperCityPatients.length === checkedList.length
    ) {
      return true;
    } else return false;
  }, [allSuperCityPatients, checkedList]);

  const checkAll2 = useMemo<boolean>(() => {
    if (
      matchedItems?.length &&
      matchedItems.length === checkedList.length &&
      matchedItems.every((item: any) => checkedList.includes(item))
    ) {
      return true;
    } else return false;
  }, [matchedItems, checkedList]);

  const deleteWholeUserId = () => {
    if (selectedPatient.id && list?.length) {
      const availablePatientsId = [];
      const availablePatients = list.find(
        (item: any) => item.id === selectedPatient.user_id
      );

      if (availablePatients && availablePatients?.patients?.length) {
        availablePatients.patients
          .filter((patient: any) => patient.super_city_id)
          .map((patient: any) => availablePatientsId.push(patient.id));
      }
      if (availablePatientsId?.length === 1) {
        return selectedPatient.user_id;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  const deletePatientParams = useMemo<any>(() => {
    let obj: any = {};
    if (!allSuperCityUser.length) {
      obj = {
        patient_ids: selectedPatient.id,
      };
    } else {
      if (allSuperCityUser.includes(selectedPatient.id)) {
        obj = {
          user_ids: selectedPatient.id,
        };
      } else {
        obj = {
          patient_ids: selectedPatient.id,
        };
        if (deleteWholeUserId()) {
          obj = {
            ...obj,
            user_ids: deleteWholeUserId(),
          };
        }
      }
    }

    return obj;
  }, [selectedPatient, allSuperCityUser]);

  const deleleBulkUserAndPatientParams = useMemo<any>(() => {
    const users: any[] = [];
    const patients: any[] = [];
    let obj: any = {};

    checkedList.map((checkedId: any) => {
      if (allSuperCityUser?.length && allSuperCityUser.includes(checkedId)) {
        users.push(checkedId);
      } else {
        patients.push(checkedId);
      }
    });

    if (list?.length) {
      allSuperCityUser.map((id: any) => {
        const allPatientsId: any = [];
        const allPatients = list.find((item: any) => {
          if (item.id === id && item.patients?.length > 1) {
            return true;
          } else {
            return false;
          }
        });

        if (allPatients && allPatients?.patients?.length) {
          allPatients.patients
            .filter((patient: any) => patient.super_city_id)
            .map((patient: any) => allPatientsId.push(patient.id));
        }

        if (
          allPatientsId.length &&
          allPatientsId.every((patientId: any) =>
            checkedList.find((checkedId: any) => checkedId === patientId)
          )
        ) {
          users.push(id);
        }
      });
    }

    if (users.length) {
      obj = {
        ...obj,
        user_ids: users.join(),
      };
    }
    if (patients.length) {
      obj = {
        ...obj,
        patient_ids: patients.join(),
      };
    }

    return obj;
  }, [checkedList, allSuperCityUser]);

  const getPatientApiCall = () => {
    dispatch(
      GetPatientsActionCreators.getPatientListAction(transformParams(input))
    );
  };

  useEffect(() => {
    dispatch(GetPatientsActionCreators.handleResetDataAction());
    dispatch(DownloadPatientsCSVActionCreators.handleResetDataAction());
    dispatch(DeletePatientActionCreators.handleResetAction());
    dispatch(SubscribeSuperCityActionCreators.handleResetAction());
  }, []);

  useEffect(() => {
    const table = tableCopyRef.current;
    if (!table) return;

    const handleCopy = (e: ClipboardEvent) => {
      const selection = window.getSelection();
      if (!selection || !selection.toString().trim()) return;

      const range = selection.getRangeAt(0);
      const cloned = range.cloneContents();

      // Get all elements with .copy-text in the selection
      const elements = Array.from(cloned.querySelectorAll(".copy-text"));
      if (!elements.length) return;

      let cleaned = "";

      elements.forEach((el, idx) => {
        const text = (el as HTMLElement).innerText.trim();

        cleaned += text;

        if (el.classList.contains("last-copy-text")) {
          cleaned += "\n";
        } else {
          cleaned += "\t";
        }
      });

      cleaned = cleaned.replace(/\t+\n/g, "\n").trim();
      e.preventDefault();
      e.clipboardData?.setData("text/plain", cleaned);
    };

    table.addEventListener("copy", handleCopy);
    return () => table.removeEventListener("copy", handleCopy);
  }, []);

  const isDebouncing = useDebouncedAction(() => {
    getPatientApiCall();
  }, [input.page, input.per_page]);

  useEffect(() => {
    if (watchStartYear) {
      setIsDisabled(false);
      resetEndDate();
      setValue("startDate", undefined);
      setValue("startMonth", undefined);

      // if (
      //   moment(`${watchStartYear}-02`).daysInMonth() < 29 &&
      //   watchStartDate &&
      //   watchStartDate === 29
      // ) {
      //   setValue("startDate", undefined);
      // }

      if (watchStartYear !== watchEndYear) {
        if (watchEndYear && watchEndYear > watchStartYear) {
          setEndMonthOptions(monthOptions);
        } else {
          const endMonthOptionsClone: any = [
            {
              id: 0,
              value: "",
              name: "--",
            },
          ];
          if (watchStartDate && watchStartDate === daysOfStartMonth) {
            for (let i = 1; i <= 12; i++) {
              if (i <= 9) {
                endMonthOptionsClone.push({
                  id: i,
                  value: i,
                  name: `0${i}`,
                  disabled: i < watchStartMonth + 1 ? true : false,
                });
              } else {
                endMonthOptionsClone.push({
                  id: i,
                  value: i,
                  name: i,
                  disabled: i < watchStartMonth + 1 ? true : false,
                });
              }
            }
          } else {
            for (let i = 1; i <= 12; i++) {
              if (i <= 9) {
                endMonthOptionsClone.push({
                  id: i,
                  value: i,
                  name: `0${i}`,
                  disabled: i < watchStartMonth ? true : false,
                });
              } else {
                endMonthOptionsClone.push({
                  id: i,
                  value: i,
                  name: i,
                  disabled: i < watchStartMonth ? true : false,
                });
              }
            }
          }

          setEndMonthOptions(endMonthOptionsClone);
        }
      } else {
        const endMonthOptionsClone: any = [
          {
            id: 0,
            value: "",
            name: "--",
          },
        ];

        if (watchStartDate && watchStartDate === daysOfStartMonth) {
          for (let i = 1; i <= 12; i++) {
            if (i <= 9) {
              endMonthOptionsClone.push({
                id: i,
                value: i,
                name: `0${i}`,
                disabled: i < watchStartMonth + 1 ? true : false,
              });
            } else {
              endMonthOptionsClone.push({
                id: i,
                value: i,
                name: i,
                disabled: i < watchStartMonth + 1 ? true : false,
              });
            }
          }
        } else {
          for (let i = 1; i <= 12; i++) {
            if (i <= 9) {
              endMonthOptionsClone.push({
                id: i,
                value: i,
                name: `0${i}`,
                disabled: i < watchStartMonth ? true : false,
              });
            } else {
              endMonthOptionsClone.push({
                id: i,
                value: i,
                name: i,
                disabled: i < watchStartMonth ? true : false,
              });
            }
          }
        }

        setEndMonthOptions(endMonthOptionsClone);
      }

      const endYearOptionsClone: any = [
        {
          id: 0,
          value: "",
          name: "----",
        },
      ];

      if (
        watchStartMonth &&
        watchStartMonth === 12 &&
        watchStartDate &&
        watchStartDate === daysOfStartMonth
      ) {
        for (let i = currentYear; i >= 1900; i--) {
          endYearOptionsClone.push({
            id: i,
            value: i,
            name: i,
            disabled: i < watchStartYear + 1 ? true : false,
          });
        }
      } else {
        for (let i = currentYear; i >= 1900; i--) {
          endYearOptionsClone.push({
            id: i,
            value: i,
            name: i,
            disabled: i < watchStartYear ? true : false,
          });
        }
      }
      // const dayClone = handleOptions(daysOfStartMonth);

      // setStartDayOptions(dayClone);

      if (watchStartYear === moment(new Date()).year()) {
        const currentMonth = moment(new Date()).month(); //month based on index
        const startMonthOptionsClone: any = [
          {
            id: 0,
            value: "",
            name: "--",
          },
        ];
        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            startMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled: i > currentMonth + 1 ? true : false,
            });
          } else {
            startMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled: i > currentMonth + 1 ? true : false,
            });
          }
        }
        setStartMonthOptions(startMonthOptionsClone);
      } else {
        setStartMonthOptions(monthOptions);
      }
      setEndYearOptions(endYearOptionsClone);
    } else {
      setIsDisabled(true);
      setValue("startMonth", undefined);
      // setValue("endYear", undefined);
      // setValue("endMonth", undefined);
      resetEndDate();
    }
  }, [watchStartYear]);

  useEffect(() => {
    // if (isResetEndDate) {
    //   setValue("startMonth", undefined);
    //   setValue("startDate", undefined);
    // }
    setValue("endDate", undefined);
    setValue("endMonth", undefined);
    const endMonthOptionsClone: any = [
      {
        id: 0,
        value: "",
        name: "--",
      },
    ];

    if (
      !watchEndYear ||
      (watchEndYear &&
        (watchStartYear === watchEndYear || watchEndYear === moment().year()))
    ) {
      if (watchStartYear === moment().year()) {
        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled:
                i < watchStartMonth || i > moment().month() + 1 ? true : false,
            });
          } else {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled:
                i < watchStartMonth || i > moment().month() + 1 ? true : false,
            });
          }
        }
      } else if (watchEndYear && watchEndYear === moment().year()) {
        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled: i > moment().month() + 1 ? true : false,
            });
          } else {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled: i > moment().month() + 1 ? true : false,
            });
          }
        }
      } else {
        // const modifiedNumber =
        //   watchStartDate && watchStartDate === daysOfStartMonth ? 1 : 0;
        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled: i < watchStartMonth ? true : false,
            });
          } else {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled: i < watchStartMonth ? true : false,
            });
          }
        }
      }

      setEndMonthOptions(endMonthOptionsClone);
    } else {
      setEndMonthOptions(monthOptions);
    }
  }, [watchEndYear]);

  useEffect(() => {
    if (watchStartMonth) {
      resetEndDate();
      // if (isResetEndDate) {
      //   resetEndDate();
      //   }
      setValue("startDate", undefined);
      // if (
      //   watchStartDate &&
      //   moment(`${watchStartYear}-${watchStartMonth}`).daysInMonth() <
      //   watchStartDate
      // ) {
      //   setValue("startDate", undefined);
      // }
      const endMonthOptionsClone: any = [
        {
          id: 0,
          value: "",
          name: "--",
        },
      ];
      let dayClone: any[] = [];
      if (
        watchStartYear === moment().year() &&
        watchStartMonth === moment().month() + 1
      ) {
        const currentDay = moment().date();
        dayClone = handleOptions2(daysOfStartMonth, currentDay);
      } else {
        dayClone = handleOptions(daysOfStartMonth);
      }

      if (!watchEndYear || (watchEndYear && watchEndYear === watchStartYear)) {
        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled: i < watchStartMonth ? true : false,
            });
          } else {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled: i < watchStartMonth ? true : false,
            });
          }
        }
        setEndMonthOptions(endMonthOptionsClone);
      } else {
        setEndMonthOptions(monthOptions);
      }

      setStartDayOptions(dayClone);
    } else {
      resetEndDate();
      setValue("startDate", undefined);
    }
  }, [watchStartMonth]);

  useEffect(() => {
    if (watchEndMonth) {
      let dayClone: any[] = [];
      setValue("endDate", undefined);
      // if (
      //   watchEndDate &&
      //   moment(
      //     `${watchEndYear || watchStartYear}-${watchEndMonth}`
      //   ).daysInMonth() < watchEndDate
      // ) {
      //   setValue("endDate", undefined);
      // }
      const currentMonth = moment().month() + 1;
      const currentDay = moment().date();
      if (
        !watchEndYear ||
        (watchEndYear &&
          (watchEndYear === watchStartYear || watchEndYear === moment().year()))
      ) {
        if (!watchStartMonth && !watchStartDate) {
          if (
            watchEndMonth === currentMonth &&
            watchEndYear === moment().year()
          ) {
            dayClone = handleOptions2(daysOfEndMonth, currentDay);
          } else {
            dayClone = handleOptions(daysOfEndMonth);
          }
        }
        if (watchStartMonth && !watchStartDate) {
          if (
            watchEndMonth === currentMonth &&
            watchEndYear === moment().year()
          ) {
            dayClone = handleOptions3(daysOfEndMonth, 1, currentDay);
          } else {
            dayClone = handleOptions(daysOfEndMonth);
          }
        }
        if (watchStartMonth && watchStartDate) {
          if (watchEndMonth === watchStartMonth) {
            if (
              watchStartMonth === currentMonth &&
              watchEndYear === moment().year()
            ) {
              if (watchEndYear === watchStartYear) {
                dayClone = handleOptions3(
                  daysOfEndMonth,
                  watchStartDate,
                  currentDay
                );
              } else {
                dayClone = handleOptions3(daysOfEndMonth, 1, currentDay);
              }
            } else {
              if (watchEndYear === watchStartYear) {
                dayClone = handleOptions(daysOfEndMonth, watchStartDate);
              } else {
                dayClone = handleOptions(daysOfEndMonth);
              }
            }
          } else {
            if (
              watchEndMonth === currentMonth &&
              watchEndYear === moment().year()
            ) {
              dayClone = handleOptions2(daysOfEndMonth, currentDay);
            } else {
              dayClone = handleOptions(daysOfEndMonth);
            }
          }
        }
      } else {
        // if (watchEndYear && watchEndYear > watchStartYear && watchEndYear !==) {
        dayClone = handleOptions(daysOfEndMonth);
      }

      setEndDayOptions(dayClone);
    } else {
      setEndDayOptions([]);
      setValue("endDate", undefined);
    }
  }, [watchEndMonth, watchStartDate, watchEndYear]);

  useEffect(() => {
    resetEndDate();
    // if (isResetEndDate) {
    // }
    if (watchStartDate === daysOfStartMonth) {
      if (!watchEndYear || (watchEndYear && watchEndYear === watchStartYear)) {
        const endMonthOptionsClone: any = [
          {
            id: 0,
            value: "",
            name: "--",
          },
        ];

        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled: i < watchStartMonth + 1 ? true : false,
            });
          } else {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled: i < watchStartMonth + 1 ? true : false,
            });
          }
        }

        setEndMonthOptions(endMonthOptionsClone);
      }

      if (
        watchStartMonth === 12 &&
        (!watchEndYear || (watchEndYear && watchEndYear === watchStartYear))
      ) {
        const endYearOptionsClone: any = [
          {
            id: 0,
            value: "",
            name: "----",
          },
        ];
        for (let i = currentYear; i >= 1900; i--) {
          endYearOptionsClone.push({
            id: i,
            value: i,
            name: i,
            disabled: i < watchStartYear + 1 ? true : false,
          });
        }

        setEndYearOptions(endYearOptionsClone);
      }
    } else {
      if (!watchEndYear || (watchEndYear && watchEndYear === watchStartYear)) {
        const endMonthOptionsClone: any = [
          {
            id: 0,
            value: "",
            name: "--",
          },
        ];

        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled: i < watchStartMonth ? true : false,
            });
          } else {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled: i < watchStartMonth ? true : false,
            });
          }
        }

        setEndMonthOptions(endMonthOptionsClone);
      } else {
        setEndMonthOptions(monthOptions);
      }

      const endYearOptionsClone: any = [
        {
          id: 0,
          value: "",
          name: "----",
        },
      ];
      for (let i = currentYear; i >= 1900; i--) {
        endYearOptionsClone.push({
          id: i,
          value: i,
          name: i,
          disabled: i < watchStartYear ? true : false,
        });
      }

      setEndYearOptions(endYearOptionsClone);
    }
  }, [watchStartDate]);

  useEffect(() => {
    if (onlinePatientDeleted) {
      notification.success({
        placement: "bottomRight",
        message: "削除しました",
        icon: <SendCompleteIcon />,
      });
    }
  }, [onlinePatientDeleted]);

  useEffect(() => {
    if (patientListData && patientListData.status === httpStatus.StatusOK) {
      const allSuperCityUser: any[] = [];
      const allSuperCityPatients: any[] = [];
      let checkedUsers: any[] = [];
      const matchedItemsArr: any[] = [];
      // setAllSuperCityUser(
      //   patientListData.result.users.map((i: any) => {
      //     return i.id;
      //   })
      // );
      if (isSearching) {
        if (patientListData.result.users.length) {
          patientListData.result.users.map((user: any) => {
            allSuperCityUser.push(user.id);

            if (user.patients?.length && user.patients[0].super_city_id) {
              if (
                user.patients?.length === 1
                // && user.patients[0]?.is_matchhing_filter
              ) {
                allSuperCityPatients.push(user.id);
                checkedUsers.push(user.id);
                matchedItemsArr.push(user.id);
              }
            }
            if (user.patients?.length > 1) {
              user.patients.map((patient: any) => {
                if (
                  patient.super_city_id
                  // && patient.is_matchhing_filter
                ) {
                  allSuperCityPatients.push(patient.id);
                }
                if (patient.is_matchhing_filter) {
                  matchedItemsArr.push(patient.id);
                }
              });
              const maxDate = user.patients.reduce(
                (latest: any, user: any) =>
                  user.date_of_birth > latest ? user.date_of_birth : latest,
                ""
              );
              if (
                user.patients.some((patient: any) => {
                  return (
                    patient?.is_matchhing_filter &&
                    patient.date_of_birth === maxDate
                  );
                })
              ) {
                const superCityUsers = user.patients
                  .filter((user: any) => user.super_city_id)
                  .map((item: any) => item.id);

                checkedUsers = [...checkedUsers, ...superCityUsers];
              }
            }
          });
        }
      } else {
        if (patientListData.result.users.length) {
          patientListData.result.users.map((user: any) => {
            allSuperCityUser.push(user.id);
            if (user.patients?.length && user.patients[0].super_city_id) {
              if (user.patients?.length === 1) {
                allSuperCityPatients.push(user.id);
              }
            }
            if (user.patients?.length > 1) {
              user.patients.map((patient: any) => {
                if (patient.super_city_id) {
                  allSuperCityPatients.push(patient.id);
                }
              });
            }
          });
        }
      }

      setList(patientListData.result.users);
      setAllSuperCityUser(allSuperCityUser);
      setAllSuperCityPatients(allSuperCityPatients);
      setTotal(patientListData?.total_record);
      setTotalPatient(patientListData?.result.total_patients);
      setTotalPatientSuperCity(
        patientListData?.result.total_patients_in_super_city
      );
      setMatchedItems(matchedItemsArr);
      if (
        isSearching &&
        settingInformationData?.result?.super_city_condition
          ?.is_household_based &&
        checkedUsers?.length &&
        !isLoadingPatientsList
      ) {
        setCheckedList(checkedUsers);
        setisCheckAll(true);
      } else {
        setisCheckAll(false);
        setCheckedList([]);
      }
    } else {
      setList([]);
      setAllSuperCityUser([]);
      setAllSuperCityPatients([]);
      setTotal(0);
      setTotalPatient(0);
      setTotalPatientSuperCity(0);
      setCheckedList([]);
      setIsSearching(false);
    }
  }, [
    patientListData,
    isSearching,
    settingInformationData,
    isLoadingPatientsList,
  ]);

  useEffect(() => {
    if (patientCSVData && !isDownloadingPatients) {
      const fileData =
        patientCSVData?.result?.data &&
        patientCSVData.result.data.length &&
        patientCSVData.result.data.length > 0
          ? patientCSVData.result.data
          : [];
      const currentDate = moment(new Date()).format("YYYYMMDD");
      const fileName = `supercity_patients_${currentDate}.csv`;
      const headers = [
        { label: "ID", key: "id" },
        { label: "氏名", key: "name" },
        { label: "性別", key: "gender" },
        { label: "年齢", key: "age" },
        { label: "生年月日", key: "date_of_birth" },
        { label: "登録番号", key: "identity_code" },
      ];

      fileData.forEach((obj: any) => {
        delete obj.is_matchhing_filter;
        delete obj.super_city_id;
        if ("relation_ship_id" in obj) {
          delete obj.relation_ship_id;
        }
        if ("is_main_patient" in obj) {
          delete obj.is_main_patient;
        }
      });

      generateCSV(fileName, headers, fileData);
      dispatch(DownloadPatientsCSVActionCreators.handleResetDataAction());
    }
  }, [patientCSVData]);

  useEffect(() => {
    if (patientListError) {
      // notification.error({
      //   placement: "bottomRight",
      //   message: "Error getting consultations list",
      //   icon: <ConfirmFailIcon width={53} height={53} />,
      // });
      setList([]);
      dispatch(GetPatientsActionCreators.handleResetDataAction());
    }
    if (downloadPatientCSVError) {
      dispatch(DownloadPatientsCSVActionCreators.handleResetDataAction());
    }
    if (deletePatientError) {
      dispatch(DeletePatientActionCreators.handleResetAction());
    }
    if (subscribeError) {
      dispatch(SubscribeSuperCityActionCreators.handleResetAction());
      setSelectedPatient({
        id: undefined,
        user_id: undefined,
        name: "",
      });
      notification.error({
        placement: "bottomRight",
        message: "登録失敗しました。",
        icon: <ConfirmFailIcon />,
      });
    }
  }, [
    patientListError,
    downloadPatientCSVError,
    deletePatientError,
    subscribeError,
  ]);

  useEffect(() => {
    if (
      deletePatientData &&
      Object.keys(deletePatientData).length &&
      deletePatientData.status === httpStatus.StatusOK &&
      !loadingDelete
    ) {
      notification.success({
        placement: "bottomRight",
        message: "ユーザーを解除しました。",
        icon: <SendCompleteIcon />,
      });
      getPatientApiCall();
      setSelectedPatient({
        id: undefined,
        user_id: undefined,
        name: "",
      });
      setCheckedList([]);
      setisCheckAll(false);
      dispatch(DeletePatientActionCreators.handleResetAction());
    }
  }, [deletePatientData, loadingDelete]);

  useEffect(() => {
    if (
      subscribeSuperCityData &&
      Object.keys(subscribeSuperCityData).length &&
      subscribeSuperCityData.status === httpStatus.StatusOK &&
      !loadingSubscribe
    ) {
      notification.success({
        placement: "bottomRight",
        message: "ユーザーを登録しました。",
        icon: <SendCompleteIcon />,
      });
      getPatientApiCall();
      setSelectedPatient({
        id: undefined,
        user_id: undefined,
        name: "",
      });
      setisCheckAll(false);
      dispatch(SubscribeSuperCityActionCreators.handleResetAction());
    }
  }, [subscribeSuperCityData, loadingSubscribe]);

  // useEffect(() => {
  //   if (isSearching && matchedItems?.length && checkedList.length) {
  //     if (matchedItems.every((item: any) => checkedList.includes(item))) {
  //       setisCheckAll(true);
  //     }
  //   }
  // }, [checkedList, matchedItems, isSearching]);

  const genderGroup: any = {
    0: "男性",
    1: "女性",
    2: "回答なし",
  };

  const handleGetFirstDateOfMonth = (year: number, month: number) => {
    const firstDay = new Date(year, month, 1);
    return moment(firstDay).format("YYYY-MM-DD");
  };

  const handleGetLastDateOfMonth = (year: number, month: number) => {
    const lastDay = new Date(year, month, 0);
    return moment(lastDay).format("YYYY-MM-DD");
  };

  const onSubmit = (data: any) => {
    let fromDate = "";
    let toDate = "";

    if (data.startYear && !data.startMonth && !data.startDate) {
      fromDate = handleGetFirstDateOfMonth(data.startYear, 0);
    }

    if (data.startMonth && !data.startDate) {
      fromDate = handleGetFirstDateOfMonth(data.startYear, data.startMonth - 1);
      // toDate = handleGetLastDateOfMonth(data.startYear, data.startMonth);
    }

    if (data.startYear && data.startMonth && data.startDate) {
      fromDate = moment(
        `${data.startYear}-${data.startMonth}-${data.startDate}`
      ).format("YYYY-MM-DD");
      // toDate = handleGetLastDateOfMonth(data.startYear, data.startMonth);
    }

    if (!data.endYear && data.startYear) {
      // if (!data.endMonth && !data.endDate) {
      //   if (data.startMonth && !data.startDate) {
      //     toDate = handleGetLastDateOfMonth(data.startYear, data.startMonth);
      //   } else if (data.startMonth && data.startDate) {
      //     toDate = moment(fromDate).add(1, "day").format("YYYY-MM-DD");
      //     // toDate = fromDate;
      //   } else {
      //     toDate = moment(new Date()).format("YYYY-MM-DD");
      //   }
      // } else if (data.endMonth && !data.endDate) {
      //   toDate = handleGetLastDateOfMonth(data.startYear, data.endMonth);
      // } else {
      //   toDate = moment(
      //     `${data.startYear}-${data.endMonth}-${data.endDate}`
      //   ).format("YYYY-MM-DD");
      // }
      toDate = moment(new Date()).format("YYYY-MM-DD");
    }
    if (data.endYear && data.endYear >= data.startYear) {
      if (!data.endMonth && !data.endDate) {
        toDate = handleGetLastDateOfMonth(data.endYear, 12);
      } else if (data.endMonth && !data.endDate) {
        toDate = handleGetLastDateOfMonth(data.endYear, data.endMonth);
      } else {
        toDate = moment(
          `${data.endYear}-${data.endMonth}-${data.endDate}`
        ).format("YYYY-MM-DD");
      }
    }
    // if (data.startYear && data.endYear) {
    //   if (!data.startMonth && !data.endMonth) {
    //     fromDate = handleGetFirstDateOfMonth(data.startYear, 0);
    //     toDate = handleGetLastDateOfMonth(data.endYear, 12);
    //   } else {
    //     fromDate = handleGetFirstDateOfMonth(
    //       data.startYear,
    //       data.startMonth - 1
    //     );
    //     toDate = handleGetLastDateOfMonth(data.endYear, data.endMonth);
    //   }

    //   if (!data.startMonth && data.endMonth) {
    //     fromDate = handleGetFirstDateOfMonth(data.startYear, 0);
    //     toDate = handleGetLastDateOfMonth(data.endYear, data.endMonth);
    //   }

    //   if (data.startMonth && !data.endMonth) {
    //     fromDate = handleGetFirstDateOfMonth(
    //       data.startYear,
    //       data.startMonth - 1
    //     );
    //     toDate = handleGetLastDateOfMonth(data.endYear, 12);
    //   }
    // }

    const params: PatientsPayload = {
      page: 1,
      user_name: data.name,
      per_page: input.per_page,
      from_date: fromDate,
      to_date: toDate,
      is_in_super_city:
        ((searchType === "birthdate" || searchType === "registration_date") &&
          (fromDate || toDate)) ||
        ((searchType === "user_name" || searchType === "registration_number") &&
          data.name)
          ? true
          : false,
    };

    if (
      ((searchType === "birthdate" || searchType === "registration_date") &&
        (fromDate || toDate)) ||
      ((searchType === "user_name" || searchType === "registration_number") &&
        data.name)
    ) {
      setIsSearching(true);
    } else {
      setIsSearching(false);
    }

    dispatch(
      GetPatientsActionCreators.getPatientListAction(transformParams(params))
    );
    setInput(params);
    setisCheckAll(false);
  };

  const handleChangePage = (page: number) => {
    setInput((prevState: any) => ({ ...prevState, page }));
    if (
      scrollAbleRef.current &&
      window.scrollY >= scrollAbleRef.current.offsetTop
    ) {
      window.scrollTo(0, 0);
    }
  };

  const handleOnChangeSizeChange = (sizeChange: number) => {
    setInput((prevState: any) => ({
      ...prevState,
      per_page: sizeChange,
      page: 1,
    }));
  };

  const ShowPagination = () => {
    return total > input.per_page ? (
      <PaginationWrapper>
        <Pagination
          current={input.page}
          onChange={handleChangePage}
          pageSize={input.per_page}
          total={total}
          showSizeChanger={false}
          showLessItems={!screens.xl}
        />
      </PaginationWrapper>
    ) : (
      <Fragment></Fragment>
    );
  };

  const DeleteGroupRegistration = () => (
    <Button
      onClick={() => setIsVisible4DeleteGroupRegistration(true)}
      background="#FB4E4E"
      color="#fff"
      name="選択したユーザーの紐付け解除"
      border="none"
      bdr="6px"
      fontSize={16}
      fontWeight={700}
    />
  );

  const handleDeselect = () => {
    setCheckedList([]);
  };

  const SubSection = () => {
    if (!checkedList.length) return <></>;
    if (checkedList.length < allSuperCityPatients.length) {
      return (
        <Message>
          <div
            style={{
              whiteSpace: "pre-wrap",
            }}
          >
            このページ内の
            <strong>{checkedList.length || 0}</strong>
            件のユーザーが選択されています。
          </div>
          <a onClick={handleDeselect}>選択を解除</a>
          <DeleteGroupRegistration />
        </Message>
      );
    }

    return (
      <Message>
        <div
          style={{
            whiteSpace: "pre-wrap",
          }}
        >
          すべてのユーザー
          <strong>{checkedList.length || 0}</strong>
          件が選択されています。
        </div>
        {/* {(!isSelectAll || total > 10) && (
            <a onClick={handleSelectCurrentPage}>
              このページの
              <strong>{currentPageData.length || 0}</strong>
              件のユーザーのみを選択
            </a>
          )} */}
        <DeleteGroupRegistration />
      </Message>
    );
  };

  const onCheckAllChange = (e: any) => {
    // if (
    //   matchedItems?.length &&
    //   matchedItems.every((item: any) => allSuperCityPatients.includes(item))
    // ) {
    //   setisCheckAll(e.target.checked);
    // }
    setisCheckAll(e.target.checked);
    setCheckedList(e.target.checked ? allSuperCityPatients : []);
  };

  const onCheckAllChange2 = (e: any) => {
    // if (!input.from_date && !input.to_date && !input.user_name) {
    //   setCheckedList(e.target.checked ? allSuperCityPatients : []);
    //   return;
    // }

    if (e.target.checked) {
      setCheckedList(matchedItems);
    } else {
      setCheckedList(
        matchedItems.filter((item: any) => !checkedList.includes(item))
      );
    }

    // if (!isCheckAll) {
    //   setisCheckAll(true);
    //   setCheckedList(matchedItems);
    //   // if (checkedList.length) {
    //   //   const checkedListClone = [...checkedList];

    //   //   matchedItems.forEach((item: any) => {
    //   //     if (!checkedList.includes(item)) {
    //   //       checkedListClone.push(item);
    //   //     }
    //   //   });
    //   //   setCheckedList(e.target.checked ? checkedListClone : []);
    //   // } else {
    //   //   setCheckedList(matchedItems);
    //   // }
    // } else {
    //   console.log(e.target.checked);
    //   if (checkedList.length) {
    //     setCheckedList(
    //       checkedList.filter((item: any) => !matchedItems.includes(item))
    //     );
    //     setisCheckAll(false);
    //   } else {
    //     setCheckedList(matchedItems);
    //   }
    // }
  };

  const handleOnChange = (value: any) => {
    setCheckedList(value);
  };

  const checkChildItem = (val: any) => {
    if (checkedList.length && checkedList.includes(val)) {
      setCheckedList(checkedList.filter((item: any) => item !== val));
    } else {
      setCheckedList([...checkedList, val]);
    }
  };

  const handleCheckAllName = () => {
    return input.from_date || input.to_date || input.user_name
      ? "検索結果を一括選択"
      : "一括選択";
  };

  return (
    <Box
      extra={
        <WrapperExtra>
          <WrapperBadge>
            <IdentityBadge>番</IdentityBadge>
            <div>登録番号</div>
          </WrapperBadge>
          <WrapperBadge>
            <BirthdayBadge>誕</BirthdayBadge>
            <div>誕生日</div>
          </WrapperBadge>
          <WrapperBadge>
            <JoinBadge>登</JoinBadge>
            <div>登録日</div>
          </WrapperBadge>
          <WrapperBadge>
            <RegistrationBadge>か</RegistrationBadge>
            <div>かかりつけ医登録</div>
          </WrapperBadge>
        </WrapperExtra>
      }
      title="ユーザー一覧"
      // subTitle={`合計人数：
      //   ${totalPatient}人（参加人数：${totalPatientSuperCity}人）`}
      subTitle={`表示合計：
        ${totalPatient}人（世帯数：${totalUsers}）`}
      padding="16px 16px 24px"
    >
      <Radio.Group
        onChange={(e: any) => {
          setSearchType(e.target.value);
          // if (
          //   (isSearching || input.page > 1) &&
          //   searchType !== e.target.value
          // ) {
          //   resetAllDate();
          // }
        }}
        value={searchType}
        style={{ marginBottom: 9 }}
      >
        <AudioWrapper>
          <Radio value="birthdate">生年月日</Radio>
          <Radio value="registration_date">登録日</Radio>
          <Radio value="user_name">ユーザー名</Radio>
          <Radio value="registration_number">登録番号</Radio>
        </AudioWrapper>
      </Radio.Group>
      <SearchWrapper>
        <form onSubmit={handleSubmit(onSubmit)}>
          <SearchWrapperLeft>
            {searchType === "birthdate" ||
            searchType === "registration_date" ? (
              <FilterWrapper>
                {/* <div>生年月日：</div> */}
                <Controller
                  control={control}
                  name="startYear"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      width="80px"
                      options={yearOptions}
                      onChange={onChange}
                      placeholder="----"
                      value={value}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="startMonth"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      width="66px"
                      options={startMonthOptions}
                      onChange={onChange}
                      placeholder="--"
                      value={value}
                      disabled={isDisabled}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="startDate"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      width="66px"
                      options={startDayOptions}
                      onChange={onChange}
                      placeholder="--"
                      value={value}
                      disabled={!watchStartYear || !watchStartMonth}
                    />
                  )}
                />

                <span className="divider-span">~</span>
                <Controller
                  control={control}
                  name="endYear"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      width="80px"
                      options={
                        endYearOptions.length ? endYearOptions : yearOptions
                      }
                      onChange={onChange}
                      placeholder="----"
                      value={value}
                      disabled={isDisabled}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="endMonth"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      width="66px"
                      options={
                        endMonthOptions.length ? endMonthOptions : monthOptions
                      }
                      onChange={onChange}
                      placeholder="--"
                      value={value}
                      disabled={!watchEndYear}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="endDate"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      width="66px"
                      options={endDayOptions}
                      onChange={onChange}
                      placeholder="--"
                      value={value}
                      // disabled={!watchEndYear || !watchEndMonth}
                      disabled={!watchEndMonth}
                    />
                  )}
                />
              </FilterWrapper>
            ) : (
              <></>
            )}
            <UserInputButtonWrapper>
              {searchType === "user_name" ||
              searchType === "registration_number" ? (
                <Controller
                  control={control}
                  name="name"
                  render={({ field: { onChange, value } }) => (
                    <Input
                      value={value}
                      // placeholder="ユーザー名で検索"
                      placeholder="入力してください"
                      height={30}
                      onChange={onChange}
                    />
                  )}
                />
              ) : (
                <></>
              )}

              <WrapperSelectAndBtn>
                <Button
                  type="submit"
                  name="検索"
                  background="#2AC769"
                  color="#FFFFFF"
                  border="none"
                  fontSize={16}
                  lineHeight="23px"
                  fontWeight={700}
                  padding="4px 16px 3px"
                />
                <Button
                  className="clear-button"
                  type="button"
                  name="クリア"
                  background="#FFFFFF"
                  color="#666666"
                  border="1px solid #cccccc"
                  fontSize={16}
                  lineHeight="23px"
                  fontWeight={500}
                  padding="3px 7px 2px"
                  onClick={() => {
                    resetAllDate();
                  }}
                />
              </WrapperSelectAndBtn>
            </UserInputButtonWrapper>
          </SearchWrapperLeft>
        </form>
      </SearchWrapper>
      <ActionWrapper>
        <div className="left">
          <SelectWrapper>
            <div
              style={{
                fontSize: 14,
                fontWeight: 500,
                marginRight: 5,
              }}
            >
              表示世帯数：
            </div>
            <Select
              value={input.per_page}
              defaultValue={10}
              options={recordOptions}
              onChange={handleOnChangeSizeChange}
            />
          </SelectWrapper>
          <Button
            icon={
              <DownloadIcon
                width="14px"
                height="14px"
                fill="currentColor"
                style={{ position: "absolute", left: 4, top: 9 }}
              />
            }
            name="CSV出力"
            background="#2AC769"
            color="#FFFFFF"
            border="none"
            fontSize={12}
            lineHeight="18px"
            fontWeight={700}
            // padding="7px 7px 7px 18px"
            onClick={() => {
              dispatch(
                DownloadPatientsCSVActionCreators.downloadPatientCSVAction(
                  transformParams(input)
                )
              );
            }}
            disabled={isDownloadingPatients}
            loading={isDownloadingPatients}
            style={{
              minWidth: 77,
              height: 32,
              padding: isDownloadingPatients
                ? "6px 7px 8px"
                : "7px 7px 7px 18px",
            }}
          />
        </div>
        <ShowPagination />
      </ActionWrapper>

      <Fragment>
        <WrapperMessage>
          <SubSection />
        </WrapperMessage>
        <WrapperCheckboxAll
          loadingPatient={isLoadingPatientsList || isDebouncing}
        >
          <CheckboxStyled
            indeterminate={indeterminate}
            onChange={(e: any) => onCheckAllChange(e)}
            checked={checkAll}
            disabled={!allSuperCityPatients?.length}
          >
            一括選択
          </CheckboxStyled>
          {input.from_date || input.to_date || input.user_name ? (
            <CheckboxStyled
              indeterminate={indeterminate2}
              onChange={(e: any) => onCheckAllChange2(e)}
              checked={checkAll2}
              disabled={!allSuperCityPatients?.length}
            >
              検索結果を一括選択
            </CheckboxStyled>
          ) : (
            <></>
          )}
        </WrapperCheckboxAll>
      </Fragment>
      {/* {list.length > 0 && (
      )} */}
      <Checkbox.Group
        style={{
          width: "100%",
          position: "relative",
          display: "block",
          minHeight: "0px",
        }}
        onChange={handleOnChange}
        value={checkedList}
      >
        {isLoadingPatientsList || isDebouncing ? (
          <LoadingWrapper style={{ top: list?.length > 0 ? "25px" : "-80px" }}>
            <Loading width="25" height="25" />
          </LoadingWrapper>
        ) : (
          <></>
        )}
        <ListUserWrapper2 ref={tableCopyRef}>
          <ListUserWrapper
            loadingPatient={isLoadingPatientsList || isDebouncing}
          >
            {list?.length > 0 &&
              list.map((item: any, index: number) => (
                <div key={item.id}>
                  <div>
                    {item.patients.map((childItem: any, idx: number) => {
                      if (!idx) {
                        return (
                          <div
                            key={childItem.id}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                              paddingLeft: 16,
                              gap: 16,
                              paddingRight: 14,
                              background: childItem.is_matchhing_filter
                                ? "#ecf5fb"
                                : "none",
                            }}
                          >
                            <CheckboxTopWrapper>
                              <CheckboxStyled2
                                // key={childItem.id}
                                value={
                                  allSuperCityPatients?.length &&
                                  allSuperCityPatients.includes(item.id)
                                    ? item.id
                                    : childItem.id
                                }
                                display={
                                  (!isSearching && childItem?.super_city_id) ||
                                  (isSearching && childItem?.super_city_id)
                                    ? // && childItem?.is_matchhing_filter
                                      true
                                    : false
                                }
                                style={{
                                  marginTop: 5,
                                  marginRight: 16,
                                  marginLeft:
                                    (!isSearching &&
                                      childItem?.super_city_id) ||
                                    (isSearching && childItem?.super_city_id)
                                      ? // && childItem?.is_matchhing_filter
                                        0
                                      : 18,
                                }}
                                // disabled={
                                //   (!isSearching && !childItem?.super_city_id) ||
                                //   (isSearching &&
                                //     ((childItem?.super_city_id &&
                                //       !childItem?.is_matchhing_filter) ||
                                //       !childItem?.super_city_id))
                                //     ? true
                                //     : false
                                // }
                                disabled={
                                  !childItem?.super_city_id ? true : false
                                }
                              >
                                <FixedWidthName
                                  width={FIXED_NAME_WIDTH}
                                  className="copy-text"
                                  style={{
                                    color: childItem?.super_city_id
                                      ? "#3B3B3B"
                                      : "#B7B7B7",
                                  }}
                                >
                                  {`${childItem.last_name} ${childItem.first_name}`}
                                </FixedWidthName>
                              </CheckboxStyled2>
                              <Item>
                                <WrapperCommonInfor>
                                  <OtherBadge>性</OtherBadge>
                                  <div className="gender copy-text">
                                    {genderGroup[childItem.gender]}
                                  </div>
                                  <OtherBadge>年</OtherBadge>
                                  <div className="age copy-text">
                                    {childItem.age}歳
                                  </div>
                                  <BirthdayBadge>誕</BirthdayBadge>
                                  {childItem.date_of_birth && (
                                    <div
                                      className={`copy-text ${
                                        !item.join_super_city_date &&
                                        !item.identity_code
                                          ? "last-copy-text"
                                          : ""
                                      }`}
                                    >
                                      {childItem.date_of_birth
                                        .split("-")
                                        .join("/")}
                                    </div>
                                  )}
                                  {item?.join_super_city_date && (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginLeft: 8,
                                      }}
                                    >
                                      <JoinBadge>登</JoinBadge>
                                      <div
                                        className={`copy-text ${
                                          !item.identity_code
                                            ? "last-copy-text"
                                            : ""
                                        }`}
                                      >
                                        {moment(
                                          item.join_super_city_date
                                        ).format("YYYY/MM/DD")}
                                      </div>
                                    </div>
                                  )}
                                  {item.identity_code && (
                                    <>
                                      <IdentityBadge style={{ marginLeft: 8 }}>
                                        番
                                      </IdentityBadge>
                                      <div className="copy-text identity-code last-copy-text">
                                        {item.identity_code}
                                      </div>
                                    </>
                                  )}
                                  {childItem?.kakaritsuke_byouin_status && (
                                    <RegistrationBadge
                                      style={{ margin: "0px 0px 0px 8px" }}
                                    >
                                      か
                                    </RegistrationBadge>
                                  )}
                                </WrapperCommonInfor>
                              </Item>
                            </CheckboxTopWrapper>
                            {childItem?.super_city_id ? (
                              <Button
                                width="54px"
                                name="解除"
                                background="#FB4E4E"
                                color="#FFFFFF"
                                border="none"
                                fontSize={16}
                                fontWeight={700}
                                padding="3px 11px 3px"
                                lineHeight="19px"
                                style={{
                                  minWidth: 54,
                                  height: 26,
                                  marginTop: 3,
                                  display:
                                    (!isSearching &&
                                      childItem?.super_city_id) ||
                                    (isSearching && childItem?.super_city_id)
                                      ? // && childItem?.is_matchhing_filter
                                        "block"
                                      : "none",
                                }}
                                onClick={() => {
                                  setIsVisible(true);
                                  setSelectedPatient({
                                    id:
                                      allSuperCityPatients?.length &&
                                      allSuperCityPatients.includes(item.id)
                                        ? item.id
                                        : childItem.id,
                                    name: `${childItem.last_name} ${childItem.first_name}
                                `,
                                    user_id: item.id,
                                  });
                                }}
                                // loading={isDeletingPatient}
                                loading={
                                  ((checkedList?.length &&
                                    checkedList.includes(
                                      allSuperCityPatients?.length &&
                                        allSuperCityPatients.includes(item.id)
                                        ? item.id
                                        : childItem.id
                                    )) ||
                                    selectedPatient.id === item.id ||
                                    selectedPatient.id === childItem.id) &&
                                  loadingDelete
                                    ? true
                                    : false
                                }
                                // disabled={
                                //   ((checkedList?.length &&
                                //     checkedList.includes(
                                //       allSuperCityPatients?.length &&
                                //         allSuperCityPatients.includes(item.id)
                                //         ? item.id
                                //         : childItem.id
                                //     )) ||
                                //     selectedPatient.id === item.id ||
                                //     selectedPatient.id === childItem.id) &&
                                //     loadingDelete
                                //     ? true
                                //     : false
                                // }
                              />
                            ) : (
                              <Button
                                name="復元"
                                width="54px"
                                background="#E89806"
                                color="#FFFFFF"
                                border="none"
                                fontSize={16}
                                fontWeight={700}
                                padding="3px 11px 3px"
                                lineHeight="19px"
                                style={{
                                  minWidth: 54,
                                  height: 26,
                                  marginTop: 3,
                                  display: checkDisplayRegisterButton(
                                    item.patients,
                                    childItem
                                  )
                                    ? "block"
                                    : "none",
                                }}
                                onClick={() => {
                                  dispatch(
                                    SubscribeSuperCityActionCreators.subcribeAction(
                                      {
                                        patient_ids: childItem.id,
                                      }
                                    )
                                  );
                                  // setIsVisible(true);
                                  setSelectedPatient({
                                    id: childItem.id,
                                    name: `${childItem.last_name} ${childItem.first_name}
                              `,
                                    user_id: item.id,
                                  });
                                }}
                                // disabled={subscribingSuperCity}
                                // loading={subscribingSuperCity}
                                // disabled={subscribingSuperCity}
                                // disabled={
                                //   selectedPatient.id === childItem.id &&
                                //     loadingSubscribe
                                //     ? true
                                //     : false
                                // }
                                loading={
                                  selectedPatient.id === childItem.id &&
                                  loadingSubscribe
                                    ? true
                                    : false
                                }
                              />
                            )}
                          </div>
                        );
                      }

                      return (
                        <div
                          key={childItem.id}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            paddingLeft: 16,
                            gap: 16,
                            paddingRight: 14,
                            background: childItem.is_matchhing_filter
                              ? "#ecf5fb"
                              : "none",
                            marginTop: 16,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                            }}
                          >
                            <CheckboxStyled
                              // key={childItem.id}
                              value={childItem.id}
                              style={{
                                marginTop: 6,
                                display:
                                  (!isSearching && childItem?.super_city_id) ||
                                  (isSearching && childItem?.super_city_id)
                                    ? // && childItem?.is_matchhing_filter
                                      "inline-flex"
                                    : "none",
                              }}
                            />
                            <Item
                              style={{
                                paddingLeft:
                                  (!isSearching && childItem?.super_city_id) ||
                                  (isSearching &&
                                    // childItem?.is_matchhing_filter &&
                                    childItem?.super_city_id)
                                    ? 36 -
                                      (item.patients.length &&
                                      item.patients[0]?.relation_ship_id === 1
                                        ? 0
                                        : 28)
                                    : 56 -
                                      (item.patients.length &&
                                      item.patients[0]?.relation_ship_id === 1
                                        ? 0
                                        : 28),
                                // marginTop: 18,
                                // background: childItem.is_matchhing_filter
                                //   ? "#ecf5fb"
                                //   : "none",
                              }}
                            >
                              <div
                                className="special-character"
                                style={{
                                  display:
                                    item.patients.length &&
                                    item.patients[0]?.relation_ship_id === 1
                                      ? "block"
                                      : "none",
                                  left:
                                    (!isSearching &&
                                      childItem?.super_city_id) ||
                                    (isSearching &&
                                      // childItem?.is_matchhing_filter &&
                                      childItem?.super_city_id)
                                      ? 15
                                      : 35,
                                }}
                              ></div>
                              <FixedWidthName
                                width={
                                  FIXED_NAME_WIDTH -
                                  (item.patients.length &&
                                  item.patients[0]?.relation_ship_id === 1
                                    ? 34
                                    : 6)
                                }
                                style={{
                                  cursor: childItem?.super_city_id
                                    ? "pointer"
                                    : "default",
                                  marginRight: 22,
                                  color: childItem?.super_city_id
                                    ? "#3B3B3B"
                                    : "#B7B7B7",
                                  marginTop: 6,
                                }}
                                onClick={() => {
                                  if (childItem?.super_city_id) {
                                    checkChildItem(childItem.id);
                                  }
                                }}
                                className="copy-text"
                              >
                                {`${childItem.last_name} ${childItem.first_name}`}
                              </FixedWidthName>
                              <WrapperCommonInfor>
                                <OtherBadge>性</OtherBadge>
                                <div className="gender copy-text">
                                  {genderGroup[childItem.gender]}
                                </div>
                                <OtherBadge>年</OtherBadge>
                                <div className="age copy-text">
                                  {childItem.age}歳
                                </div>
                                <BirthdayBadge>誕</BirthdayBadge>
                                {childItem.date_of_birth && (
                                  <div className="copy-text last-copy-text">
                                    {childItem.date_of_birth
                                      .split("-")
                                      .join("/")}
                                  </div>
                                )}
                                {/* {childItem?.join_super_city_date && (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: 8,
                                  }}
                                >
                                  <JoinBadge>登</JoinBadge>
                                  <div>
                                    {moment(
                                      childItem.join_super_city_date
                                    ).format("YYYY/MM/DD")}
                                  </div>
                                </div>
                              )} */}

                                {childItem?.kakaritsuke_byouin_status && (
                                  <RegistrationBadge
                                    style={{ margin: "0px 0px 0px 8px" }}
                                  >
                                    か
                                  </RegistrationBadge>
                                )}
                              </WrapperCommonInfor>
                            </Item>
                          </div>
                          {childItem?.super_city_id ? (
                            <Button
                              width="54px"
                              name="解除"
                              background="#FB4E4E"
                              color="#FFFFFF"
                              border="none"
                              fontSize={16}
                              fontWeight={700}
                              padding="3px 11px 3px"
                              lineHeight="19px"
                              style={{
                                minWidth: 54,
                                height: 26,
                                marginTop: 3,
                                display:
                                  (!isSearching && childItem?.super_city_id) ||
                                  (isSearching && childItem?.super_city_id)
                                    ? // && childItem?.is_matchhing_filter
                                      "block"
                                    : "none",
                              }}
                              onClick={() => {
                                setIsVisible(true);
                                setSelectedPatient({
                                  id: childItem.id,
                                  name: `${childItem.last_name} ${childItem.first_name}
                                `,
                                  user_id: item.id,
                                });
                              }}
                              // disabled={isDeletingPatient}
                              // disabled={
                              //   ((checkedList?.length &&
                              //     checkedList.includes(childItem.id)) ||
                              //     selectedPatient.id === childItem.id) &&
                              //     loadingDelete
                              //     ? true
                              //     : false
                              // }
                              loading={
                                ((checkedList?.length &&
                                  checkedList.includes(childItem.id)) ||
                                  selectedPatient.id === childItem.id) &&
                                loadingDelete
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <Button
                              width="54px"
                              name="復元"
                              background="#E89806"
                              color="#FFFFFF"
                              border="none"
                              fontSize={16}
                              fontWeight={700}
                              padding="3px 11px 3px"
                              lineHeight="19px"
                              style={{
                                minWidth: 54,
                                height: 26,
                                marginTop: 3,
                                display: checkDisplayRegisterButton(
                                  item.patients,
                                  childItem
                                )
                                  ? "block"
                                  : "none",
                              }}
                              onClick={() => {
                                dispatch(
                                  SubscribeSuperCityActionCreators.subcribeAction(
                                    {
                                      patient_ids: childItem.id,
                                    }
                                  )
                                );
                                setSelectedPatient({
                                  id: childItem.id,
                                  name: `${childItem.last_name} ${childItem.first_name}
                              `,
                                  user_id: item.id,
                                });
                              }}
                              loading={
                                selectedPatient.id === childItem.id &&
                                loadingSubscribe
                                  ? true
                                  : false
                              }
                              // disabled={subscribingSuperCity}
                              // disabled={
                              //   selectedPatient.id === childItem.id &&
                              //     loadingSubscribe
                              //     ? true
                              //     : false
                              // }
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {index !== list.length - 1 && <DotLine />}
                </div>
              ))}
          </ListUserWrapper>
        </ListUserWrapper2>
      </Checkbox.Group>

      <div style={list.length > 0 ? { marginTop: 30 } : {}}>
        <ShowPagination />
      </div>

      {!list.length && !isLoadingPatientsList && (
        <div
          style={{
            fontSize: 16,
            fontWeight: 500,
            lineHeight: "26px",
            marginTop: 8,
          }}
        >
          登録ユーザーがいません。
        </div>
      )}

      <ModalStyled
        type="confirm"
        footer={
          <WrapperBtnFooter>
            <Button
              onClick={() => setIsVisible(false)}
              background="#E0E0E0"
              color="#fff"
              name="キャンセル"
              border="none"
              bdr="6px"
              fontSize={16}
              fontWeight={700}
            />
            <Button
              onClick={() => {
                dispatch(
                  DeletePatientActionCreators.deletePatientAction(
                    deletePatientParams
                  )
                );
                setIsVisible(false);
              }}
              background="#FB4E4E"
              color="#fff"
              name="はい"
              border="none"
              bdr="6px"
              fontSize={16}
              fontWeight={700}
            />
          </WrapperBtnFooter>
        }
        visible={isVisible}
      >
        <TextModal>{selectedPatient.name}さんの登録を解除します。</TextModal>

        <TextModal>本当によろしいですか？</TextModal>
      </ModalStyled>

      <ModalStyled
        type="confirm"
        footer={
          <WrapperBtnFooter>
            <Button
              onClick={() => setIsVisible4DeleteGroupRegistration(false)}
              background="#E0E0E0"
              color="#fff"
              name="キャンセル"
              border="none"
              bdr="6px"
              fontSize={16}
              fontWeight={700}
            />
            <Button
              onClick={() => {
                dispatch(
                  DeletePatientActionCreators.deletePatientAction(
                    deleleBulkUserAndPatientParams
                  )
                );
                setIsVisible4DeleteGroupRegistration(false);
              }}
              background="#FB4E4E"
              color="#fff"
              name="はい"
              border="none"
              bdr="6px"
              fontSize={16}
              fontWeight={700}
            />
          </WrapperBtnFooter>
        }
        visible={isVisible4DeleteGroupRegistration}
      >
        <TextModal>選択したユーザーの一括解除をします。</TextModal>
        <TextModal>本当によろしいですか？</TextModal>
      </ModalStyled>
    </Box>
  );
};

export default UserList;
